export class OutletPeer {
    static constructFromPlainObjectList(plainList) {
        const outletPeers = [];
        if (plainList && Array.isArray(plainList)) {
            for (const obj of plainList) {
                outletPeers.push(OutletPeer.constructFromPlainObject(obj));
            }
        }
        return outletPeers;
    }
    static constructFromPlainObject(plain) {
        let outletPeer = new OutletPeer();
        outletPeer = Object.assign(outletPeer, plain);
        return outletPeer;
    }
    constructor() {
        this.userId = '';
        this.loginName = '';
        this.firstName = '';
        this.lastName = '';
    }
    getId() {
        return this.userId;
    }
    getLoginName() {
        return this.loginName;
    }
    getFirstName() {
        return this.firstName;
    }
    getLastName() {
        return this.lastName;
    }
}
//# sourceMappingURL=outletPeer.js.map